import { Box, Button, Typography } from '@mui/material';
import { useMemo, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { Link, useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import photo from '../../assets/images/homeImage.png';
import AccountCreation from './AccountCreation';
import styles from './login.module.scss';
import cognitoService from '../../core/service/cognito.service';
import { connect } from 'react-redux';
import { SET_USER_DATA } from '../../constants/actionTypes';
import NavMobile from '../Nav/NavMobile';
import NavDesktop from '../Nav/NavDesktop';
import logo from '../../assets/images/logo-black.svg';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import colors from '../../utils/colors';
import { getRandomRightSectionImageSrc } from '../../utils/images';

const mapStateToProps = (state) => {
    return {
        user: state.user.currentUser
    };
};

const mapDispatchToProps = (dispatch) => ({
    onSetUserData: (payload) => dispatch({ type: SET_USER_DATA, payload })
});

const LoginPage = (props) => {
    const { t } = useTranslation();
    const [showImage, setShowImage] = useState(true);
    const [username, setUsername] = useState('');
    const [emailError, setEmailError] = useState('');
    const [confirmCode, setConfirmCode] = useState(false);
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    const location = useLocation();
    const isFromWatch = location.state?.fromWatch || false;

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            const authReq = await cognitoService.authenticate(username);
            props.onSetUserData({ username, step: true });
            if (authReq) {
                setEmailError(null);
                setShowImage(false);
                setConfirmCode(true);
            }
            setLoading(false);
        } catch (e) {
            setLoading(false);
            if (e.code && e.code === 'UserLambdaValidationException') {
                setEmailError(t('UserNotExistMessage'));
                return;
            } else if (e.code && e.code === 'UserNotFoundException') {
                setEmailError(t('UserNotExistMessage'));
                return;
            }

            setEmailError(t('UserNotExistMessage'));
        }
    };

    const backgroundPhotoSrc = useMemo(() => getRandomRightSectionImageSrc(), []);

    return (
        <Box className={styles.registerContainer}>
            {isMobile && <NavMobile />}
            <Box className={styles.content}>
                {!isMobile && (
                    <Box className={styles.flex} sx={{ padding: 0, margin: '0 -4rem' }}>
                        <img
                            style={{ cursor: 'pointer', width: '40px', height: '40px' }}
                            onClick={() => history.push('/home')}
                            src={logo}
                            alt="logo"
                        />
                        <Box className={styles.flexNav}>
                            {/* <Link>{t('About')}</Link> */}
                            <Link to={'/terms-and-conditions'}>{t('TermsAndConditions')}</Link>
                        </Box>
                    </Box>
                )}
                {isMobile && showImage && (
                    <Box className={styles.imageWrapper}>
                        <Box className={styles.backgroundImage}></Box>
                        <Box className={styles.gradientOverlay}></Box>
                    </Box>
                )}
                <Box
                    className={styles.registerContent}
                    sx={{ margin: isMobile && showImage ? '60% auto 0 !important' : '' }}>
                    <Typography
                        sx={{
                            margin: '1rem 0',
                            zIndex: 2,
                            fontSize: isMobile ? '38px' : '64px',
                            letterSpacing: isMobile ? '-0.78px' : '-1.28px'
                        }}
                        fontFamily={'InstrumentSans-bold'}
                        textAlign={'center'}>
                        {isFromWatch ? t('AccessYourPurchase') : t('WelcomeBack')}
                    </Typography>
                    <AccountCreation
                        isLogin={true}
                        handleSubmit={handleSubmit}
                        setUsername={setUsername}
                        username={username}
                        confirmCode={confirmCode}
                        emailError={emailError}
                        loading={loading}
                        setEmailError={setEmailError}
                    />
                    <Typography textAlign={'center'}>
                        {t('FirstTime')}
                        <Link to={'/register'} style={{ color: colors.primary }}>
                            {t('SignUp')}
                        </Link>
                    </Typography>
                </Box>
            </Box>
            {!isMobile && (
                <Box className={styles.imageSection} sx={{ overflow: 'hidden' }}>
                    <img className={styles.image} src={backgroundPhotoSrc} alt="home-image" />
                </Box>
            )}
        </Box>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
